/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type FC, type JSX } from 'react';

import CheckIcon from '../../../Checkbox/Icon';
import { LiContainer } from './styled';
import { sumClasses } from '../../../../../../utils/misc';

type ListItemProps = {
  name: string;
  value: string;
  defaultValue: any;
  className: string;
  disabled: boolean;
  i: number;
  currentIndex: number;
  isSelected: boolean;
  addLabel: any;
  currentSelection: any;
  expanded?: boolean;
  handleItemClick: any;
  handleOnFocus: any;
  labelId: string;
  isListBox: boolean;
  item: any;
  hide: boolean;
  label: any;
  customSelectedIcon: any;
  handleButtonKeyDown: any;
  columns?: number;
  iconOnTheRight?: boolean;
};

const ListItem: FC<ListItemProps> = ({
  name,
  value,
  defaultValue,
  className,
  disabled,
  i,
  currentIndex,
  isSelected,
  addLabel,
  currentSelection,
  expanded,
  handleItemClick,
  handleOnFocus,
  labelId,
  isListBox,
  item,
  label,
  hide,
  customSelectedIcon,
  handleButtonKeyDown,
  columns,
  iconOnTheRight,
}): JSX.Element => {
  const checkIcon = <CheckIcon {...{ labelId, value: isSelected }} />;
  const iconLeft = !iconOnTheRight ? checkIcon : null;
  const iconRight = iconOnTheRight ? checkIcon : null;
  const id = `exp_elem_${name}_${value}`;
  const listClassName = sumClasses([
    className,
    disabled ? 'disabled' : '',
    i === currentIndex ? 'focused' : '',
    isSelected ? 'selected' : '',
    addLabel ? 'whith-label' : '',
    hide ? 'hidden' : '',
    columns === 2 ? 'two-columns' : '',
    iconOnTheRight ? 'icon-on-the-right' : '',
  ]);

  return (
    <LiContainer
      id={id}
      role="option"
      aria-disabled={disabled || undefined}
      className={listClassName}
      hasAddLabel={!!addLabel}
      isListBox={isListBox}
      {...{
        ...((!isListBox || hide) && value === defaultValue
          ? { style: { visibility: 'hidden', position: 'absolute' } }
          : {}),
        ...(currentSelection && currentSelection.value === value ? { 'aria-selected': 'true' } : {}),
        ...(disabled ? {} : { onClick: () => handleItemClick(item) }),
        ...(expanded && !disabled ? { tabIndex: 0 } : {}),
        ...(expanded && !disabled ? { onKeyDown: (e: any) => handleButtonKeyDown(e) } : {}),
        ...(expanded ? { onFocus: (e: any) => handleOnFocus(e, i) } : {}),
      }}
    >
      {customSelectedIcon ? (
        <span>
          {label} {isSelected ? customSelectedIcon : null}
        </span>
      ) : (
        <>
          {isListBox ? null : iconLeft}
          {addLabel ? (
            <div
              className="listbox-label"
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              {label}
            </div>
          ) : (
            label
          )}
          {addLabel ? <div {...{ className: 'add-label' }}>{addLabel}</div> : null}
          {isListBox ? null : iconRight}
        </>
      )}
    </LiContainer>
  );
};

export default ListItem;
